'use strict';

var resultsLimit = 12;
var $arcProductGrid = $('#arcProductGrid');
var ArcRatingFilterHelper = require('bwconstants/ArcRatingFilterHelper');

function buildProductElement(productData) {
	var outerLayerText = $arcProductGrid.data('text-outerlayer');
	var baseLayerText = $arcProductGrid.data('text-baselayer');
	var layeredArcRatingText = $arcProductGrid.data('text-layeredarcrating');
	var layeredCatRatingText = $arcProductGrid.data('text-layeredcatrating');
	var viewDetailsText = $arcProductGrid.data('text-viewdetails');
	var outer = productData.outerLayer;
	var base = productData.baseLayer;
	var ratingTypeAtpv = $arcProductGrid.data('text-ratingtypeatpv');
	var ratingTypeEbt = $arcProductGrid.data('text-ratingtypeebt');
	var ratingType = productData.EbtArcRating !== '' ? ratingTypeEbt : ratingTypeAtpv;

	return '<div class="col-6 col-sm-4 product-tile-wrap" data-layeredarcrating="' + productData.layeredArcRating + '">'
	+ '	<div class="product product--arc-rating">'
	+ '		<div class="product-tile">'
	+ '			<div class="image-container">'
	+ '				<a class="tile-link" href="#">'
	+ '					<img src="' + outer.imageUrl + '" alt="' + outer.name + '" class="tile-image tile-image--1"/>'
	+ '					<img src="' + base.imageUrl + '" alt="' + base.name + '" class="tile-image tile-image--2"/>'
	+ '				</a>'
	+ '			</div>'
	+ '			<div class="tile-body">'
	+ '				<div class="product__outer mb-2">'
	+ '					<div class="product__style">' + outerLayerText + ': ' + outer.style + '</div>'
	+ '					<div class="product__name">' + outer.name + '</div>'
	+ '				</div>'
	+ '				<div class="product__base mb-2">'
	+ '					<div class="product__style">' + baseLayerText + ': ' + base.style + '</div>'
	+ '					<div class="product__name">' + base.name + '</div>'
	+ '				</div>'
	+ '				<div class="product__rating mb-2">' + layeredArcRatingText + ': ' + ratingType + ' ' + productData.layeredArcRating + ' </div>'
	+ '				<div class="product__rating mb-2">' + layeredCatRatingText + ': ' + productData.layeredCatRating + ' </div>'
	+ '				<button data-action="launch-detail-modal" data-rating="' + productData.layeredArcRating + '" data-ratingtype="' + ratingType + '" data-catrating="' + productData.layeredCatRating + '" data-outer="' + outer.style + '" data-base="' + base.style + '" class="product__link btn btn-link d-block text-left">' + viewDetailsText + '</button>'
	+ '			</div>'
	+ '		</div>'
	+ '	</div>'
	+ '</div>';
}

function buildDetailModalElement(productData) {
	var outerLayerText = $arcProductGrid.data('text-outerlayer');
	var baseLayerText = $arcProductGrid.data('text-baselayer');
	var layeredArcRatingText = $arcProductGrid.data('text-layeredarcrating');
	var layeredCatRatingText = $arcProductGrid.data('text-layeredcatrating');
	var fabricText = $arcProductGrid.data('text-fabric');
	var sizeText = $arcProductGrid.data('text-size');
	var careText = $arcProductGrid.data('text-care');
	var colorsText = $arcProductGrid.data('text-colors');
	var pdplinkText = $arcProductGrid.data('text-pdplink');
	var outer = productData.outerLayer;
	var base = productData.baseLayer;

	return '<!-- Modal -->'
	+ '<div class="modal arc-rating-detail-modal fade" id="detailModal" role="dialog">'
	+ '<div class="modal-dialog">'
	+ '<!-- Modal content-->'
	+ '<div class="modal-content">'
	+ '<div class="modal-header">'
	+ '<h4 class="modal-title">' + layeredArcRatingText + ': ' + productData.ratingType + ' ' + productData.layeredArcRating + '<br>' + layeredCatRatingText + ': ' + productData.layeredCatRating + '</h4>'
	+ '<button type="button" class="close pull-right" data-dismiss="modal"></button>'
	+ '</div>'
	+ '<div class="modal-body">'
	+ '<div class="row">'
	+ '	<div class="product product--outer col-md-6">'
	+ '		<div class="image-container mb-3">'
	+ '			<img src="' + outer.imageUrl + '" alt="' + outer.name + '" class="d-block"/>'
	+ '		</div>'
	+ '		<div class="product__style">' + outerLayerText + ': ' + outer.style + '</div>'
	+ '		<div class="product__name mb-2">' + outer.name + '</div>'
	+ '		<div class="product__attributes mb-2">'
	+ '			<div class="product__fabrics mb-1"><span class="product__label">' + fabricText + ':</span> ' + outer.fabrics + '</div>'
	+ '			<div class="product__sizes mb-1"><span class="product__label">' + sizeText + ':</span> ' + outer.size + '</div>'
	+ '			<div class="product__care mb-1"><span class="product__label">' + careText + ':</span> ' + outer.care + '</div>'
	+ '			<div class="product__colors mb-1"><span class="product__label">' + colorsText + ':</span> ' + outer.color + '</div>'
	+ '		</div>'
	+ '		<a class="product__pdplink btn btn-link" href="' + outer.productPageUrl + '">' + pdplinkText + '</a>'
	+ '	</div>'
	+ '	<div class="product product--base col-md-6">'
	+ '		<div class="image-container mb-3">'
	+ '			<img src="' + base.imageUrl + '" alt="' + base.name + '" class="d-block"/>'
	+ '		</div>'
	+ '		<div class="product__style">' + baseLayerText + ': ' + base.style + '</div>'
	+ '		<div class="product__name mb-2">' + base.name + '</div>'
	+ '		<div class="product__attributes mb-2">'
	+ '			<div class="product__fabrics mb-1"><span class="product__label">' + fabricText + ':</span> ' + base.fabrics + '</div>'
	+ '			<div class="product__sizes mb-1"><span class="product__label">' + sizeText + ':</span> ' + base.size + '</div>'
	+ '			<div class="product__care mb-1"><span class="product__label">' + careText + ':</span> ' + base.care + '</div>'
	+ '			<div class="product__colors mb-1"><span class="product__label">' + colorsText + ':</span> ' + base.color + '</div>'
	+ '		</div>'
	+ '		<a class="product__pdplink btn btn-link" href="' + base.productPageUrl + '">' + pdplinkText + '</a>'
	+ '	</div>'
	+ '</div>'
	+ '</div>'
	+ '</div>'
	+ '</div>'
	+ '</div>';
}

function getAttributeValues(attribute) {
	var valueArray = [];

	if (Array.isArray(attribute)) {
		$.each(attribute, function(key, value) {
			valueArray.push(value.displayValue);
		});
	} else {
		return attribute;
	}

	return valueArray.join(', ');
}

function launchDetailModal(rating, ratingType, catRating, outerStyle, baseStyle) {
	var arcRatingModel = $('[data-arcrating]').data('arcrating');
	var distinctProductInfos = arcRatingModel.ArcRatingData.DistinctProductInfos;

	var productData = {
		layeredArcRating: rating,
		layeredCatRating: catRating,
		ratingType: ratingType,
		outerLayer: {
			style: outerStyle,
			imageUrl: distinctProductInfos[outerStyle].DefaultImageUrl,
			name: distinctProductInfos[outerStyle].Name,
			fabrics: getAttributeValues(distinctProductInfos[outerStyle].Fabrics),
			size: getAttributeValues(distinctProductInfos[outerStyle].Size),
			care: getAttributeValues(distinctProductInfos[outerStyle].WashCare),
			color: getAttributeValues(distinctProductInfos[outerStyle].Color),
			productPageUrl: distinctProductInfos[outerStyle].DetailPageUrl
		},
		baseLayer: {
			style: baseStyle,
			imageUrl: distinctProductInfos[baseStyle].DefaultImageUrl,
			name: distinctProductInfos[baseStyle].Name,
			fabrics: getAttributeValues(distinctProductInfos[baseStyle].Fabrics),
			size: getAttributeValues(distinctProductInfos[baseStyle].Size),
			care: getAttributeValues(distinctProductInfos[baseStyle].WashCare),
			color: getAttributeValues(distinctProductInfos[baseStyle].Color),
			productPageUrl: distinctProductInfos[baseStyle].DetailPageUrl
		}
	};

	var detailModalElement = buildDetailModalElement(productData);

	if ($('#detailModal').length !== 0) {
		$('#detailModal').remove();
	}

	$('body').append(detailModalElement);
	$('#detailModal').modal('show');
}

function getProducts(arcRatingModel, filter, value, ratingModifier, extraRefinementType) {
	var products = [];
	var sortedProducts = [];
	var distinctProductInfos = arcRatingModel.ArcRatingData.DistinctProductInfos;
	var outerStyleInfos = arcRatingModel.ArcRatingData.OuterStyleInfos;
	var styleInfos = [];

	if (filter === 'refine-by-style') {
		if (extraRefinementType.hasOwnProperty('type')) {
			if (value === 'all') {
				styleInfos = ArcRatingFilterHelper.GetStyleInfoByLayeredArcRating(extraRefinementType.value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
			} else {
				styleInfos = ArcRatingFilterHelper.GetStyleInfoByStyleAndRating(value, extraRefinementType.value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
			}
		} else if (value === 'all') {
			styleInfos = outerStyleInfos;
		} else {
			styleInfos = ArcRatingFilterHelper.GetStyleInfoByStyle(value, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
		}
	} else if (filter === 'refine-by-type') {
		if (extraRefinementType.hasOwnProperty('type')) {
			if (value === 'all') {
				styleInfos = ArcRatingFilterHelper.GetStyleInfoByLayeredArcRating(extraRefinementType.value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
			} else {
				styleInfos = ArcRatingFilterHelper.GetStyleInfoByProductTypeAndRating(value, extraRefinementType.value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
			}
		} else if (value === 'all') {
			styleInfos = outerStyleInfos;
		} else {
			styleInfos = ArcRatingFilterHelper.GetStyleInfoByProductType(value, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
		}
	} else if (filter === 'refine-by-rating') {
		if (extraRefinementType.hasOwnProperty('type')) {
			if (extraRefinementType.type === 'refine-by-style') {
				if (value === 'all') {
					styleInfos = ArcRatingFilterHelper.GetStyleInfoByStyle(extraRefinementType.value, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
				} else {
					styleInfos = ArcRatingFilterHelper.GetStyleInfoByStyleAndRating(extraRefinementType.value, value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
				}
			} else if (extraRefinementType.type === 'refine-by-type') {
				if (value === 'all') {
					styleInfos = ArcRatingFilterHelper.GetStyleInfoByProductType(extraRefinementType.value, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
				} else {
					styleInfos = ArcRatingFilterHelper.GetStyleInfoByProductTypeAndRating(extraRefinementType.value, value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
				}
			}
		} else if (value === 'all') {
			styleInfos = outerStyleInfos;
		} else {
			styleInfos = ArcRatingFilterHelper.GetStyleInfoByLayeredArcRating(value, ratingModifier, outerStyleInfos, distinctProductInfos).OuterStyleInfos;
		}
	} else {
		styleInfos = outerStyleInfos;
	}

	$.each(styleInfos, function(outerKey, outerLayer) {
		$.each(outerLayer.BaseStyleInfos, function(baseKey, baseLayer) {
			if (baseLayer.Style !== outerLayer.Style) {
				try {
					var productData = {
						layeredArcRating: baseLayer.LayeredArcRating,
						layeredCatRating: baseLayer.LayeredCatRating,
						AtpArcRating: baseLayer.AtpArcRating,
						EbtArcRating: baseLayer.EbtArcRating,
						outerLayer: {
							style: outerLayer.Style,
							imageUrl: distinctProductInfos[outerLayer.Style].DefaultImageUrl,
							name: distinctProductInfos[outerLayer.Style].Name
						},
						baseLayer: {
							style: baseLayer.Style,
							imageUrl: distinctProductInfos[baseLayer.Style].DefaultImageUrl,
							name: distinctProductInfos[baseLayer.Style].Name
						}
					};
					if (productData.layeredArcRating !== '') {
						var $productElement = buildProductElement(productData);
						products.push([$productElement, baseLayer.LayeredArcRating]);
					}
				} catch (e) {}
			}
		});
	});

	products.sort(function(a, b) {
		return a[1] - b[1];
	});

	products.forEach(function(product) {
		var $product = $(product[0]);
		if (sortedProducts.length >= resultsLimit) {
			$product.addClass('d-none');
		}
		sortedProducts.push($product);
	});

	return sortedProducts;
}


function updatePagingStatus() {
	var pageSize = $arcProductGrid.find('.product-tile-wrap:not(.d-none)').length;
	var resultsTotal = $arcProductGrid.find('.product-tile-wrap').length;
	var pagePercentage = Math.round(pageSize / resultsTotal * 100);

	$('.arc-rating-results').find('.page-size').text(pageSize);
	$('.arc-rating-results').find('.results-total').text(resultsTotal);
	$('#pagePercentage').css('width', pagePercentage + '%');

	if (pageSize === resultsTotal) {
		$('#showMoreButton').addClass('d-none');
	} else {
		$('#showMoreButton').removeClass('d-none');
	}
}

function updateResults(products) {
	$arcProductGrid.empty();
	$.each(products, function(key, product) {
		$arcProductGrid.append(product);
	});
	updatePagingStatus();
}

module.exports = function() {
	var arcRatingModel = $('[data-arcrating]').data('arcrating');
	var ratingModifier = 'RatingSearchModifier' in arcRatingModel && arcRatingModel.RatingSearchModifier !== '' ? arcRatingModel.RatingSearchModifier : '5';

	// Show all results
	var products = getProducts(arcRatingModel, null, null, ratingModifier, null);
	updateResults(products);

	// Show more results
	$('body').on('click', '[data-action=show-more-results]', function() {
		var counter = 0;
		$('.product-tile-wrap').each(function(index, element) {
			if (counter < resultsLimit && $(element).hasClass('d-none')) {
				$(element).removeClass('d-none');
				counter++;
			}
		});
		updatePagingStatus();
	});

	// Launch detail modal
	$('body').on('click', '[data-action=launch-detail-modal]', function(event) {
		var rating = $(event.target).data('rating');
		var ratingType = $(event.target).data('ratingtype');
		var catRating = $(event.target).data('catrating');
		var outerStyle = $(event.target).data('outer');
		var baseStyle = $(event.target).data('base');

		launchDetailModal(rating, ratingType, catRating, outerStyle, baseStyle);
	});

	$('body').on('click', '.product--arc-rating .product-tile a.tile-link', function(event) {
		event.preventDefault();
		$(this).closest('.product-tile').find('[data-action=launch-detail-modal]').trigger('click');
	});

	// Update results on filter change
	$('body').on('change', '.refinement select', function(event) {
		var refinementType = $(event.target).data('action');
		var value = $(event.target).val();
		var extraRefinementType = {};

		// if one of the main dropdowns is changed, pass rating if selected
		if (refinementType === 'refine-by-style' || refinementType === 'refine-by-type') {
			if ( $('.refinement select[data-action=refine-by-rating] option:selected').val() !== 'all' ) {
				extraRefinementType = {
					type: 'refine-by-rating',
					value: $('.refinement select[data-action=refine-by-rating] option:selected').val()
				};
			}
		}

		// if one of the main dropdowns is in use, disable the other ...
		if (refinementType === 'refine-by-style') {
			if (value === 'all') {
				$('.refinement select[data-action=refine-by-type]').removeClass('disabled');
				$('.refinement select[data-action=refine-by-type]').siblings('.chosen-container').removeClass('disabled');
			} else {
				$('.refinement select[data-action=refine-by-type]').addClass('disabled');
				$('.refinement select[data-action=refine-by-type]').siblings('.chosen-container').addClass('disabled');
			}
		} else if (refinementType === 'refine-by-type') {
			if (value === 'all') {
				$('.refinement select[data-action=refine-by-style]').removeClass('disabled');
				$('.refinement select[data-action=refine-by-style]').siblings('.chosen-container').removeClass('disabled');
			} else {
				$('.refinement select[data-action=refine-by-style]').addClass('disabled');
				$('.refinement select[data-action=refine-by-style]').siblings('.chosen-container').addClass('disabled');
			}
		}

		if (refinementType === 'refine-by-rating') {
			if ( $('.refinement select[data-action=refine-by-style] option:selected').val() !== 'all' ) {
				extraRefinementType = {
					type: 'refine-by-style',
					value: $('.refinement select[data-action=refine-by-style] option:selected').val()
				};
			} else if ( $('.refinement select[data-action=refine-by-type] option:selected').val() !== 'all' ) {
				extraRefinementType = {
					type: 'refine-by-type',
					value: $('.refinement select[data-action=refine-by-type] option:selected').val()
				};
			}
		}

		$('.refinement select').each(function() {
			if ($(this).find('option:selected').val() !== 'all') {
				$('.refinements__controls .reset-parent').show();
				return false;
			} else {
				$('.refinements__controls .reset-parent').hide();
			}
		});

		products = getProducts(arcRatingModel, refinementType, value, ratingModifier, extraRefinementType);
		updateResults(products);

	});

	// show refinements when filter button clicked
	$('.container').on('click', 'button.filter-results', function() {
		$('.modal-background').show();
		$('.refinement-bar').addClass('refinement-bar--active');
	});

	// refinements close button
	$('body').on('click', '.refinement-bar button.close, .modal-background', function() {
		$('.modal-background').hide();
		$('.refinement-bar').removeClass('refinement-bar--active');
	});

	// Close refinement bar and hide modal background if user resizes browser
	$(window).resize(function() {
		$('.modal-background').hide();
		$('.refinement-bar').removeClass('refinement-bar--active');
	});

	$('.container').on('click', '.refinements__controls a.reset', function(e) {
		e.preventDefault();
		$('.refinement select').removeClass('disabled');
		$('.refinement select').siblings('.chosen-container').removeClass('disabled');
		$('.refinement select option[value="all"]').prop("selected", true);
		$('.refinement select').trigger('chosen:updated');
		$('.refinements__controls .reset-parent').hide();
		var products = getProducts(arcRatingModel, null, null, ratingModifier, null);
		updateResults(products);
	});
};
